export default "__VITE_ASSET__BJj_iWP1__"